/** Shared XML helpers for the Office (PPTX / XLSX) part parsers in pdf.ts and xlsx.ts. */

/** Undo the XML entities Office writes into part files. */
export function decodeEntities(s: string): string {
  return s
    .replace(/&lt;/g, '<').replace(/&gt;/g, '>')
    .replace(/&apos;/g, "'").replace(/&quot;/g, '"')
    .replace(/&#(\d+);/g, (_, n) => String.fromCharCode(Number(n)))
    .replace(/&amp;/g, '&'); // last: an escaped "&amp;lt;" must not become "<"
}
